module.exports = __webpack_public_path__ + "img/itunes.fe6fc2a7.svg";